import { HttpRequestError, MonthClosing, MonthClosingStatus } from '../../types';
import {
  ActionType,
  MonthClosingAnnulFailureAction,
  MonthClosingAnnulSuccessAction,
  MonthClosingChangeAnnulAction,
  MonthClosingChangeFilterCountryAction,
  MonthClosingChangeFilterAccountingMonthAction,
  MonthClosingChangeFilterStatusAction,
  MonthClosingCloseFailureAction,
  MonthClosingCloseSuccessAction,
  MonthClosingFindFailureAction,
  MonthClosingFindRequestedAction,
  MonthClosingFindSuccessAction,
} from './types';

export const monthClosingChangeFilterCountry = (
  country: string
): MonthClosingChangeFilterCountryAction => ({
  type: ActionType.monthClosingChangeFilterCountry,
  country,
});

export const monthClosingChangeFilterAccountingMonth = (
  accountingMonth: Date | null
): MonthClosingChangeFilterAccountingMonthAction => ({
  type: ActionType.monthClosingChangeFilterAccountingMonth,
  accountingMonth,
});

export const monthClosingChangeFilterStatus = (
  status: MonthClosingStatus | null
): MonthClosingChangeFilterStatusAction => ({
  type: ActionType.monthClosingChangeFilterStatus,
  status,
});

export const monthClosingFindRequested = (): MonthClosingFindRequestedAction => ({
  type: ActionType.monthClosingFindRequested,
});

export const monthClosingFindSuccess = (
  monthClosing: MonthClosing[]
): MonthClosingFindSuccessAction => ({
  type: ActionType.monthClosingFindSuccess,
  monthClosing,
});

export const monthClosingFindFailure = (
  error: HttpRequestError
): MonthClosingFindFailureAction => ({
  type: ActionType.monthClosingFindFailure,
  error,
});

export const monthClosingCloseSuccess = (): MonthClosingCloseSuccessAction => ({
  type: ActionType.monthClosingCloseSuccess,
});

export const monthClosingCloseFailure = (
  error: HttpRequestError
): MonthClosingCloseFailureAction => ({
  type: ActionType.monthClosingCloseFailure,
  error,
});

export const monthClosingChangeAnnul = (
  monthClosing: MonthClosing | undefined
): MonthClosingChangeAnnulAction => ({
  type: ActionType.monthClosingChangeAnnul,
  monthClosing,
});

export const monthClosingAnnulSuccess = (): MonthClosingAnnulSuccessAction => ({
  type: ActionType.monthClosingAnnulSuccess,
});

export const monthClosingAnnulFailure = (
  error: HttpRequestError
): MonthClosingAnnulFailureAction => ({
  type: ActionType.monthClosingAnnulFailure,
  error,
});
